export default [
  { path: '/base/user', name: 'BaseUser', component: () => import(/* webpackChunkName: "base-user" */ './index.vue') }
]